<script>
  // internal components
  import Table from "../component/table.svelte";

  // external libraries
  import { Label, Input } from "sveltestrap";
  import { csvParse, tsvParse } from "d3";

  // internal imports
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import { setData } from "../../editor/component/data.js";
  import { data, dataInfo } from "../../editor/storage.js";

  let fileType;
  let reader = new FileReader();
  reader.addEventListener("load", () => {
    if (fileType === "json") data.set(JSON.parse(reader.result));
    else if (fileType === "csv") data.set(csvParse(reader.result));
    else if (fileType === "tsv") data.set(tsvParse(reader.result));
    localStorage.setItem("data", JSON.stringify($data));
    dataInfo.set(setData($data));
  });

  function processData(event) {
    let file = event.target.files[0];
    if (file.name.endsWith(".json")) fileType = "json";
    else if (file.name.endsWith(".csv")) fileType = "csv";
    else if (file.name.endsWith(".tsv")) fileType = "tsv";
    reader.readAsText(file);
  }
</script>

<section class="second-level-menu-full">
  <h2>
    {firstLevelMenus["data"]?.title || "Data"}
  </h2>

  <div class="dupo-menu-pane mb-2" style="width: 240px;">
    <div class="dupo-menu-pane-row">
      <Label for="data_file">Upload Data</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        type="file"
        name="data_file"
        id="data_file"
        class="custom-form-select"
        accept=".csv, .json, .tsv"
        on:change={(event) => processData(event)}
      />
    </div>
  </div>
  {#if $data && $dataInfo?.header && $dataInfo?.columns}
    <div class="dupo-menu-pane mb-2">
      <!-- todo: make a viewer -->
      <div class="dupo-menu-pane-row">
        <Label>Current data</Label>
      </div>
      <div class="dupo-menu-pane-form-row">
        <div
          class="custom-form-select"
          style="height: calc(100vh - 180px); overflow-x: scroll; overflow-y: scroll;"
        >
          <Table
            tableData={$data}
            tableColumns={$dataInfo.columns}
            tableID={"data-preview"}
          />
        </div>
      </div>
    </div>
  {/if}
</section>
